export const realEstateKeys = {
  root: () =>
    ({
      service: 'ace',
      scope: 'real-estate',
    }) as const,

  list: ({ personID }: { personID?: string }) =>
    ({
      ...realEstateKeys.root(),
      entity: 'real-estate-list',
      personID,
    }) as const,

  applicationCollateral: ({ applicationID }: { applicationID?: string }) =>
    ({
      ...realEstateKeys.root(),
      entity: 'application-collateral',
      applicationID,
    }) as const,
};
